




































































































import {Component, Prop, Vue, Inject, Watch} from 'vue-property-decorator';
import FlexGridModel, {MainRow} from '@/models/FlexGridModel';
import FlexGridColumnTypeEnum from '@/enums/FlexGridColumnTypeEnum';
import CCheckbox from '@/components/base/checkbox/CCheckbox.vue';
@Component({
    components: {CCheckbox},
})
export default class FlexGridTableMainRow extends Vue {
    @Prop() info!: MainRow;
    @Inject() moduleName!: string;
    @Inject() selectable!: boolean;
    @Inject() editBtnCellMinWidth!: string;
    @Inject() hideCopyButton!: boolean;
    @Inject() deleteDisableFn!: Function;

    private columnTypeEnum = FlexGridColumnTypeEnum;

    get mainData(): FlexGridModel | null {
        return this.$store.state[this.moduleName].data;
    }
    get isEditable(): number {
        return this.$store.state[this.moduleName].isEditable;
    }

    get emptyCellsCount(): number {
        return this.$store.getters[`${this.moduleName}/emptyCellsCount`];
    }
    get hasSubcomponents(): number {
        return this.$store.getters[`${this.moduleName}/hasSubcomponents`];
    }

    get transpose(): boolean {
        return this.$store.state[this.moduleName].transpose;
    }

    get trStyle() {
        return {
            display: this.info.show ? null : 'none',
            'background-color': '#fff',
        };
    }

    get additionalCellsCount() {
        return this.emptyCellsCount - Number(this.hasSubcomponents);
    }

    onToggleClick(bool: boolean) {
        if (this.info.subcomponent) this.info.subcomponent.show = bool;
        this.info.isOpen = bool;
    }
}
